import React from "react";
import { SpadeEmblem } from "./SpadeEmblem";

export const Logo = ({ className = "" }) => {
    return (
        <a
            href="https://heylink.me/casinobiat/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="site-logo"
            className={`inline-flex items-center gap-3 select-none ${className}`}
            aria-label="casinobiat.online"
        >
            <SpadeEmblem size={52} />
            <span
                className="text-2xl md:text-[28px] font-extrabold tracking-tight"
                style={{
                    fontFamily: "Inter, sans-serif",
                    letterSpacing: "0.02em",
                }}
            >
                <span className="gold-text">CASINO</span>
                <span className="text-white">BIAT</span>
                <span className="gold-text text-base md:text-lg ml-1.5 font-bold">
                    .online
                </span>
            </span>
        </a>
    );
};
